export const ResponsiveCarouselConfig = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1200, min: 790 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 790, min: 0 },
    items: 1,
  },
}
